const DEFAULTS = {
    h1: 'Ogłoszenia motoryzacyjne',
    h2: 'Ogłoszenia samochodowe',

    title: 'Samochody.pl',
    description: 'Samochody.pl - serwis ogłoszeń kupna, sprzedaży, wynajmu samochodów.',

    image: 'https://samochody.pl/assets/icons/large-samochody-fb.png',
    imageWidth: 400,
    imageHeight: 400,
}

export default DEFAULTS